import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { getDetailItemAPI } from 'modules/display-item-master/api';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getCargoUserListAPI, getContainerInformationAPI, getFilterCargoTraceInformationAPI } from './api';
import {
  filterCargoTraceSuccess,
  filterCargoTrace,
  filterContainerInfoSuccess,
  filterContainerInfo,
  filterContainerInfoFailure,
  filterCargoTraceFailure,
  filterUserDataSuccess,
  filterUserData,
  filterColumnItem,
  filterColumnItemSuccess,
} from './slice';

export const CARGO_SEARCH_SCREEN_ID = '040101';

function* fetchCargoTraceInformation({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getFilterCargoTraceInformationAPI, trimQueryData(payload));
    yield put(filterCargoTraceSuccess(response));
  } catch (error) {
    yield put(filterCargoTraceFailure());
  }
}

function* fetchContainerInformationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getContainerInformationAPI, trimQueryData(payload));
    yield put(filterContainerInfoSuccess(response.data));
  } catch (error: any) {
    yield put(
      filterContainerInfoFailure({
        loading: false,
        message: error?.message,
      })
    );
  }
}

function* fetchCargoUserList({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getCargoUserListAPI, trimQueryData(payload));
    yield put(filterUserDataSuccess(response));
  } catch (error) {
    yield put(filterCargoTraceFailure());
  }
}

function* fetchColumnItemScreen() {
  try {
    const response: ResponseGenerator = yield call(getDetailItemAPI, { SCREEN_ID: CARGO_SEARCH_SCREEN_ID });
    yield put(filterColumnItemSuccess(response?.data?.ITEMS));
  } catch (error) {
    yield put(filterCargoTraceFailure());
  }
}

function* watchCargoTraceInformation() {
  yield takeLatest(filterCargoTrace, fetchCargoTraceInformation);
  yield takeLatest(filterContainerInfo, fetchContainerInformationSaga);
  yield takeLatest(filterUserData, fetchCargoUserList);
  yield takeLatest(filterColumnItem, fetchColumnItemScreen);
}

export default watchCargoTraceInformation;
